import { DuoToneTextDefaultCombinedProps } from './types';

const usePresenter = (props: DuoToneTextDefaultCombinedProps): DuoToneTextDefaultCombinedProps => {
  return props;
};

export default usePresenter;
